// extracted by mini-css-extract-plugin
export default {"table":"TableLayout_table__0xR+1"};